<div class="row">
  <div class="col">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Admin</li>
      </ol>
    </nav>
  </div>
</div>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <h1 class="h2">Admin</h1>
</div>
<div class="card mb-3">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h4>Rep Selection</h4>
      </div>
    </div>
    <app-rep-selection></app-rep-selection>
  </div>
</div>
<div class="card mb-3">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h4>Report Data</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="text-muted">
          Generates the client care report rows for the current month. Does nothing if they already exist.
        </p>
        <button class="btn btn-primary" type="button" [disabled]="isGeneratingReportData"
          (click)="generateReportData()">
          <fa-icon class="me-2" [icon]="isGeneratingReportData ? faCircleNotch : faFileLines"
            [spin]="isGeneratingReportData"></fa-icon>
          {{ isGeneratingReportData ? 'Generating...' : 'Generate Report Data' }}
        </button>
        <ul class="list-unstyled mt-3 mb-0" *ngIf="reportDataStatuses.length > 0">
          <li *ngFor="let status of reportDataStatuses" class="mb-1"
            [ngClass]="status.state === 'failed' ? 'text-danger' : 'text-muted'">
            <fa-icon class="me-2"
              [icon]="status.state === 'finished' ? faCheck : status.state === 'failed' ? faTriangleExclamation : faCircleNotch"
              [spin]="status.state === 'generating'"></fa-icon>
            {{ reportDataStatusText(status) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
